import { NavMenuKeys } from '@/routes/navMenu';
import { lazyImport } from '@/utils/lazyImport';
import React from 'react';
import { PageName } from '../constant';
const {
  Page
} = lazyImport(() => import('../index'), 'Page');
export const routes = [{
  name: PageName,
  path: '/deposit',
  element: /*#__PURE__*/React.createElement(Page, null),
  module: NavMenuKeys.Finance,
  enable: true
}];